import 'twin.macro';
import 'styled-components/macro';

import { Placeholder } from 'component-lib/molecules/placeholder/Placeholder';

export interface ServiceTabPlaceholderProps {
  title: string;
}

export const ServiceTabPlaceholder = ({ title }: ServiceTabPlaceholderProps) => {
  return (
    <Placeholder
      tw="bg-blue-darkest text-white h-full rounded-none"
      description="will load when the challenge is played"
      title={title}
    />
  );
};
